import { render, staticRenderFns } from "./DialogPendingReport.vue?vue&type=template&id=4b1492ea"
import script from "./DialogPendingReport.vue?vue&type=script&lang=ts"
export * from "./DialogPendingReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports